// tslint:disable:max-line-length

import React from 'react';

export const EditorUnderline = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect x="1.5" y="14.5" width="13" height="1.5" />
      <path d="M3,7.8V0h2.2v7.6c0,1.9,0.8,3,2.8,3s2.8-1.1,2.8-3V0H13v7.8c0,2.8-1.6,4.7-4.9,4.7C4.5,12.5,3,10.6,3,7.8z" />
    </svg>
  );
};
